import "./App.css";
import aos from "aos";
import "aos/dist/aos.css";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import { auth, fireStoredb } from "./firebase_config";
import { useEffect, useState } from "react";

import { onAuthStateChanged } from "firebase/auth";
import PageNotFound from "./Components/PageNotFound";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Posts from "./Pages/Social/Posts";
import Admin from "./Pages/Social/Admin";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { ToastTimer } from "./data";
import toast from "react-simple-toasts";
import Service from "./Pages/Services/Service";
import WebStore from "./Pages/Services/WebStore";
import AppStore from "./Pages/Services/AppStore";
import Footer from "./Pages/Home/Footer";

// function

function App() {
  const [user, setuser] = useState({});
  const [maintenance, setmaintenance] = useState(false);
  useEffect(() => {
    aos.init({
      offset: 250,
      duration: 600,
      delay: 100,
    });
    onAuthStateChanged(auth, (currUser) => {
      if (currUser) {
        setuser(currUser);
        load();
      } else auth.signOut();
    });
  }, []);
  const load = async () => {
    try {
      const q = query(
        collection(fireStoredb, "user"),
        where("admin", "==", true)
      );
      onSnapshot(q, (querySnapshot) => {
        setmaintenance(querySnapshot.docs[0].data().maintenance);
      });
    } catch (err) {
      return toast(err.message, ToastTimer);
    }
  };

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            exact
            path="/"
            element={maintenance === true ? <PageNotFound /> : <Home />}
          />
          <Route
            exact
            path="/login"
            element={maintenance === true ? <PageNotFound /> : <Login />}
          />
          <Route
            exact
            path="/admin"
            element={maintenance === true ? <PageNotFound /> : <Admin />}
          />
          <Route
            exact
            path="/posts"
            element={user?.uid && maintenance === false ? <Posts /> : <Login />}
          />
          <Route
            exact
            path="/service"
            element={maintenance === false ? <Service /> : <PageNotFound />}
          />
          <Route
            exact
            path="/service/webstore"
            element={maintenance === false ? <WebStore /> : <PageNotFound />}
          />
          <Route
            exact
            path="/service/appstore"
            element={maintenance === false ? <AppStore /> : <PageNotFound />}
          />

          <Route exact path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
